import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { customersRouter } from './routing/customersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  customersAccessControl,
  customersPrivacyRequestsAccessControl,
} from './access-control/customersAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'customers',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'customers-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [customersRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Customers,
      attachToV2: NavEntryPoint.OperationsCustomerSupport,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Search and view customer information and details',
          labelId: 'customersDomain.search.pageTitle',
          route: 'customers-search',
          position: 1,
          positionNavV2: 5,
          accessControl: customersAccessControl,
          inToolPermissions: [
            {
              slug: Permission.CustomersAppeasementsModifyAccess,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.CustomersAppeasementsModifyAccess,
            },
            {
              slug: Permission.CustomersAppeasementsView,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.CustomersAppeasementsView,
            },
          ],
        },
        {
          type: 'item',
          llmDescription: 'Manage customer privacy requests and data deletion',
          labelId: 'customersDomain.privacyRequests.pageTitle',
          route: 'customers-privacy-requests',
          position: 2,
          positionNavV2: 6,
          accessControl: customersPrivacyRequestsAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
